module.exports = __webpack_public_path__ + "static/media/logo-mysql-26329.2bc611d4.png";